import * as Yup from 'yup';

export const passwordHelp = 'Use at least 15 characters (maximum 72 bytes).';
export const accountPassword = () => Yup.string().required('Password is required')
  .test('password-length', passwordHelp, value => !!value && Array.from(value).length >= 15 &&
    unescape(encodeURIComponent(value)).length <= 72 && !value.includes('\0'));
export const resetSchema = Yup.object().shape({
  token: Yup.string().required('Token is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: accountPassword(),
  password_confirmation: Yup.string().required('Confirm your password').oneOf([Yup.ref('password')], 'Passwords must match'),
});
